import { getDeviceType } from "./getDeviceType"

export const getFilenameForAudio = (
  name,
  state,
  activeTutorial,
  activeTrial,
  currentQuestion,
  modalOptions: null | string = null,
  _options: string | undefined = undefined,
  gender: string | undefined = undefined,
  isFinalScreen: boolean | undefined = undefined,
  isFinalWithPrevAnswerScreen: boolean | undefined = undefined
) => {
  let convertedId = ""
  let moveAndMoveBisTest = Array<string>()
  const device = getDeviceType() === "desktop" ? "web" : "mobile"
  const isDesktop = getDeviceType() === "desktop"

  if (currentQuestion && name !== "Swipe") {
    const item = currentQuestion.value?.item
    const proposals = currentQuestion.value?.proposals || []

    if ((name === "Move" || name === "MoveBis") && item) {
      moveAndMoveBisTest = [
        `${item}.mp3`,
        ...proposals.map((proposal) => `${proposal.proposal}.mp3`),
      ]
    } else {
      convertedId = String(currentQuestion.value?.item_id).padStart(2, "0")
    }
  }

  // Fonctions spécifiques pour gérer les états complexes
  function handleTrialState(activeTrial, isDesktop, userGender) {
    const trials = {
      0: isDesktop
        ? [
            "swipe.tutorial.one.mp3",
            `swipe.tutorial.one_task_web_${userGender}.mp3`,
            `swipe.tutorial.one_description_web_${userGender}.mp3`,
          ]
        : [
            "swipe.tutorial.one.mp3",
            "swipe.tutorial.one_task_mobile.mp3",
            `swipe.tutorial.one_description_mobile_${userGender}.mp3`,
          ],
      1: isDesktop
        ? [
            "swipe.tutorial.two.mp3",
            `swipe.tutorial.two_task_web_${userGender}.mp3`,
            `swipe.tutorial.two_description_web_${userGender}.mp3`,
          ]
        : [
            "swipe.tutorial.two.mp3",
            "swipe.tutorial.two_task_mobile.mp3",
            `swipe.tutorial.two_description_mobile_${userGender}.mp3`,
          ],
      2: isDesktop
        ? [
            "swipe.tutorial.three.mp3",
            `swipe.tutorial.three_task.mp3`,
            `swipe.tutorial.three_description_web.mp3`,
          ]
        : [
            "swipe.tutorial.three.mp3",
            "swipe.tutorial.three_task.mp3",
            `swipe.tutorial.three_description_mobile.mp3`,
          ],
      3: [
        "swipe.tutorial.success.title.mp3",
        `swipe.tutorial.success.body.mp3`,
      ],
    }

    return trials[activeTrial] || []
  }

  function handleTestState(currentQuestion, userGender) {
    const questNum = currentQuestion + 1
    const questStr = questNum.toString().padStart(2, "0")

    if (isFinalScreen) {
      return [
        "swipe.final.title.mp3",
        "swipe.final.subtitle.mp3",
        "swipe.final.body.mp3",
      ]
    }

    if (isFinalWithPrevAnswerScreen) {
      return ["swipe.final.previous.title.mp3", "swipe.final.previous.body.mp3"]
    }

    return [
      `swipe.cards.v1.pair_${questStr}.a_${userGender}.mp3`,
      `swipe.cards.v1.pair_${questStr}.b_${userGender}.mp3`,
    ]
  }

  if (name === "Swipe") {
    const audioFiles = {
      options: {
        WELL_DONE: ["swipe.tutorial.correct.mp3"],
        TRY_AGAIN: ["swipe.tutorial.incorrect.mp3"],
        FINAL: [
          "swipe.final.title.mp3",
          "swipe.final.subtitle.mp3",
          "swipe.final.body.mp3",
        ],
        FINAL_WITH_PREV_ANSWER: [
          "swipe.final.previous.title.mp3",
          "swipe.final.previous.body.mp3",
        ],
        break: [
          "swipe.assessment.idle.title.mp3",
          "swipe.assessment.idle.body.mp3",
        ],
      },
      state: {
        welcomeBack: ["swipe.landing.welcome_back.mp3"],
        trial: (activeTrial, isDesktop, userGender) =>
          handleTrialState(activeTrial, isDesktop, userGender),
        test: (currentQuestion, userGender) =>
          handleTestState(currentQuestion, userGender),
      },
    }

    if (modalOptions && audioFiles.options[modalOptions]) {
      return audioFiles.options[modalOptions]
    }

    const stateHandler = audioFiles.state[state]
    if (typeof stateHandler === "function") {
      if (state == "trial") {
        return stateHandler(activeTrial, isDesktop, gender)
      } else if (state == "test") {
        return stateHandler(currentQuestion, gender)
      }
    }
    return stateHandler || []
  }

  if (name === "Drive") {
    if (modalOptions === "break") {
      return [
        "drive.assessment.idle.title.mp3",
        "drive.assessment.idle.body.mp3",
      ]
    } else if (modalOptions === "restartNow") {
      return [
        "drive.assessment.redo.now.title.mp3",
        "drive.assessment.redo.now.body.mp3",
      ]
    } else if (modalOptions === "restartLater") {
      return [
        "drive.assessment.redo.later.title.mp3",
        "drive.assessment.redo.later.body.mp3",
      ]
    }

    switch (state) {
      case "intro":
        return [
          "drive.landing.body_1.mp3",
          "drive.landing.body_2.mp3",
          "drive.landing.body_3.mp3",
        ]
      case "welcomeBack":
        return ["drive.landing.body_1.mp3", "drive.landing.body_2.mp3"]

      case "rules":
        return [
          "drive.rules.title.mp3",
          "drive.rules.rule_1.mp3",
          "drive.rules.rule_2.mp3",
          "drive.rules.rule_3.mp3",
          "drive.rules.rule_4.mp3",
          "drive.rules.rule_5.mp3",
        ]

      case "practice":
        return [
          "drive.tutorial.practice.title.mp3",
          "drive.tutorial.practice.body.mp3",
        ]

      case "tuto":
        if (activeTutorial === 1) {
          return [
            "drive.tutorial.success.title.mp3",
            "drive.tutorial.success.body.mp3",
          ]
        }
        return [
          "drive.tutorial.title.mp3",
          "drive.tutorial.instruction.mp3",
          "drive.tutorial.statement_example.mp3",
          "drive.tutorial.option_1.mp3",
          "drive.tutorial.option_2.mp3",
        ]

      case "test":
        return [
          `drive.test.statement.mp3`,
          `drive.test.item_${convertedId}.a.mp3`,
          `drive.test.item_${convertedId}.b.mp3`,
        ]

      case "nativeLanguage":
        return [
          "drive.end.title.mp3",
          "drive.end.body.mp3",
          "drive.end.check.q1.mp3",
          "drive.end.check.language.mp3",
        ]

      case "wholesomeConditions":
        return ["drive.end.check.q2.mp3", "drive.end.check.condition.mp3"]

      case "restart":
        return ["drive.end.check.q3.mp3", "drive.end.check.restart.mp3"]

      default:
        console.error("Unhandled state:", state)
        return []
    }
  }

  if (name === "Brain") {
    if (modalOptions === "break") {
      return [
        "brain.assessment.idle.title.mp3",
        "brain.assessment.idle.body.mp3",
      ]
    }

    switch (state) {
      case "welcomeBack":
        return [
          "brain.landing.body_1.mp3",
          "brain.landing.body_2.mp3",
          "brain.landing.body_3.mp3",
        ]

      case "resume":
        return [
          `general.assessment.resume.title_${gender}.mp3`,
          "general.assessment.resume.body.mp3",
          "brain.tutorial.checklist.item_1.mp3",
          "brain.tutorial.checklist.item_2.mp3",
          "brain.tutorial.checklist.item_3.mp3",
          "brain.tutorial.checklist.item_4.mp3",
        ]

      case "tuto":
      case "test":
      case "loadResults":
      case "final":
        return []

      case "tutoConfirmation":
        return [
          "brain.tutorial.checklist.title.mp3",
          "brain.tutorial.checklist.body.mp3",
          "brain.tutorial.checklist.item_1.mp3",
          "brain.tutorial.checklist.item_2.mp3",
          "brain.tutorial.checklist.item_3.mp3",
          "brain.tutorial.checklist.item_4.mp3",
        ]

      case "tutoEnd":
        return ["brain.tutorial.end.title.mp3", "brain.tutorial.end.body.mp3"]

      default:
        console.error("Unhandled state:", state)
        return []
    }
  }

  if (name === "Voice") {
    switch (state) {
      case "welcomeBack":
        return ["voice.landing.body_1.mp3"]

      case "authorizeRefused":
        return [
          `voice.microphone.denied.title.mp3`,
          `voice.microphone.denied.body_1_${device}.mp3`,
          `voice.microphone.denied.body_2_${device}.mp3`,
          `voice.microphone.denied.body_3_${device}.mp3`,
          `voice.microphone.denied.body_4_${device}.mp3`,
          `voice.microphone.denied.body_5.mp3`,
        ]

      case "tuto":
      case "test":
      case "loadResults":
        return []

      case "end":
        return [
          "voice.end.title.mp3",
          "voice.end.body_1.mp3",
          "voice.end.body_2.mp3",
        ]

      default:
        console.error("Unhandled state:", state)
        return []
    }
  }

  if (name === "Move") {
    if (modalOptions === "break") {
      return ["move.assessment.idle.title.mp3", "move.assessment.idle.body.mp3"]
    } else if (modalOptions === "restartNow") {
      return [
        "move.assessment.redo.now.title.mp3",
        "move.assessment.redo.now.body.mp3",
      ]
    } else if (modalOptions === "restartLater") {
      return [
        "move.assessment.redo.later.title.mp3",
        "move.assessment.redo.later.body.mp3",
      ]
    }

    switch (state) {
      case "welcomeBack":
        return ["move.landing.body_1.mp3", "move.landing.body_2.mp3"]

      case "tuto":
        if (activeTutorial === 1) {
          return [
            "move.tutorial.success.title.mp3",
            "move.tutorial.success.body.mp3",
          ]
        }
        return [
          "move.tutorial.title.mp3",
          "move.tutorial.instruction.mp3",
          "move.tutorial.statement_example.mp3",
          "move.tutorial.option_1.mp3",
          "move.tutorial.option_2.mp3",
          "move.tutorial.option_3.mp3",
          "move.tutorial.option_4.mp3",
        ]

      case "test":
        return moveAndMoveBisTest

      case "loadResults":
        return []

      default:
        console.error("Unhandled state:", state)
        return []
    }
  }

  if (name === "MoveBis") {
    if (modalOptions === "break") {
      return [
        "movebis.assessment.idle.title.mp3",
        "movebis.assessment.idle.body.mp3",
      ]
    } else if (modalOptions === "restartNow") {
      return [
        "movebis.assessment.redo.now.title.mp3",
        "movebis.assessment.redo.now.body.mp3",
      ]
    } else if (modalOptions === "restartLater") {
      return [
        "movebis.assessment.redo.later.title.mp3",
        "movebis.assessment.redo.later.body.mp3",
      ]
    }

    switch (state) {
      case "welcomeBack":
        return ["movebis.landing.body_1.mp3", "movebis.landing.body_2.mp3"]

      case "tuto":
        if (activeTutorial === 1) {
          return [
            "movebis.tutorial.success.title.mp3",
            "movebis.tutorial.success.body.mp3",
          ]
        }
        return [
          "movebis.tutorial.title.mp3",
          "movebis.tutorial.instruction.mp3",
          "movebis.tutorial.statement_example.mp3",
          "movebis.tutorial.option_1.mp3",
          "movebis.tutorial.option_2.mp3",
          "movebis.tutorial.option_3.mp3",
          "movebis.tutorial.option_4.mp3",
        ]

      case "test":
        return moveAndMoveBisTest

      case "loadResults":
        return []

      default:
        console.error("Unhandled state:", state)
        return []
    }
  }
}
